class BlogAssignmentTabs extends HTMLElement {
  connectedCallback() {
    this.targetId = this.dataset.target;
    this.currentBlog = this.dataset.currentBlog || '';
    this.singularLabel = this.dataset.singularLabel || 'article';
    this.pluralLabel = this.dataset.pluralLabel || 'articles';
    this.videoBlogHandle = this.dataset.videoBlogHandle || 'videos';

    this.tabs = Array.from(this.querySelectorAll('[data-blog-tab]'));
    this.singleView = document.querySelector(`[data-blog-view-root="${this.targetId}"][data-blog-view="single"]`);
    this.allView = document.querySelector(`[data-blog-view-root="${this.targetId}"][data-blog-view="all"]`);
    this.countEl = document.querySelector(`[data-blog-count-root="${this.targetId}"]`);
    this.toolbar = document.querySelector(`[data-blog-toolbar="${this.targetId}"]`);
    this.filterBtn = document.querySelector('[data-blog-filter-btn]');
    this.headingEl = document.querySelector('.blog-posts--landing h1') || document.querySelector('.blog-posts--landing h2');
    this.breadcrumbTitleEl = document.querySelector('[data-blog-breadcrumb-title]');
    this.allLabel = this.querySelector('[data-blog-tab="all"]')?.textContent.trim() || 'All';
    this.originalCountText = this.countEl ? this.countEl.textContent.trim() : '';
    this.originalCount = this.countEl ? parseInt(this.originalCountText, 10) || 0 : 0;

    // All-tab pagination setup
    this.allItems = this.allView ? Array.from(this.allView.querySelectorAll('[data-blog-all-item]')) : [];
    this.allPaginationRoot = document.querySelector(`[data-blog-all-pagination-root="${this.targetId}"]`);
    this.allPageNumbersEl = this.allPaginationRoot
      ? this.allPaginationRoot.querySelector('[data-blog-all-page-numbers]')
      : null;
    this.allPrevBtn = this.allPaginationRoot
      ? this.allPaginationRoot.querySelector('[data-blog-all-page-btn="prev"]')
      : null;
    this.allNextBtn = this.allPaginationRoot
      ? this.allPaginationRoot.querySelector('[data-blog-all-page-btn="next"]')
      : null;
    this.allPerPageButtons = this.allPaginationRoot
      ? Array.from(this.allPaginationRoot.querySelectorAll('[data-blog-all-per-page-btn]'))
      : [];

    const defaultPerPage = this.allPaginationRoot
      ? parseInt(this.allPaginationRoot.dataset.defaultPerPage, 10)
      : 24;
    this.allItemsPerPage = defaultPerPage || 24;
    this.allCurrentPage = 1;
    this.isFetching = false;

    this.tabs.forEach((tab) => tab.addEventListener('click', this.handleTabClick));
    if (this.allPrevBtn) this.allPrevBtn.addEventListener('click', () => this.goToAllPage(this.allCurrentPage - 1));
    if (this.allNextBtn) this.allNextBtn.addEventListener('click', () => this.goToAllPage(this.allCurrentPage + 1));
    this.allPerPageButtons.forEach((btn) =>
      btn.addEventListener('click', () => this.setAllItemsPerPage(parseInt(btn.dataset.blogAllPerPageBtn, 10)))
    );

    // Single-tab pagination setup
    this.singleItems = this.singleView ? Array.from(this.singleView.querySelectorAll('[data-blog-single-item]')) : [];
    this.singlePaginationRoot = document.querySelector(`[data-blog-single-pagination-root="${this.targetId}"]`);
    this.singlePageNumbersEl = this.singlePaginationRoot
      ? this.singlePaginationRoot.querySelector('[data-blog-single-page-numbers]')
      : null;
    this.singlePrevBtn = this.singlePaginationRoot
      ? this.singlePaginationRoot.querySelector('[data-blog-single-page-btn="prev"]')
      : null;
    this.singleNextBtn = this.singlePaginationRoot
      ? this.singlePaginationRoot.querySelector('[data-blog-single-page-btn="next"]')
      : null;
    this.singlePerPageButtons = this.singlePaginationRoot
      ? Array.from(this.singlePaginationRoot.querySelectorAll('[data-blog-single-per-page-btn]'))
      : [];

    const singleDefaultPerPage = this.singlePaginationRoot
      ? parseInt(this.singlePaginationRoot.dataset.defaultPerPage, 10)
      : 24;
    this.singleItemsPerPage = singleDefaultPerPage || 24;
    this.singleCurrentPage = 1;

    if (this.singlePrevBtn) this.singlePrevBtn.addEventListener('click', () => this.goToSinglePage(this.singleCurrentPage - 1));
    if (this.singleNextBtn) this.singleNextBtn.addEventListener('click', () => this.goToSinglePage(this.singleCurrentPage + 1));
    this.singlePerPageButtons.forEach((btn) =>
      btn.addEventListener('click', () => this.setSingleItemsPerPage(parseInt(btn.dataset.blogSinglePerPageBtn, 10)))
    );

    window.addEventListener('popstate', this.syncFromLocation);

    this.syncFromLocation();
  }

  disconnectedCallback() {
    this.tabs.forEach((tab) => tab.removeEventListener('click', this.handleTabClick));
    window.removeEventListener('popstate', this.syncFromLocation);
  }

  handleTabClick = (event) => {
    const tab = event.currentTarget;
    if (tab.dataset.blogTab !== 'all') return;

    event.preventDefault();
    if (tab.href) {
      history.pushState({}, '', tab.href);
    }
    this.showAll();
  };

  syncFromLocation = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('view') === 'all') {
      this.showAll();
    } else {
      this.showSingle();
    }
  };

  closeOpenDialogs() {
    document.querySelectorAll('dialog[open]').forEach((dialog) => {
      dialog.close();
    });
  }

  showAll() {
    if (!this.allView || !this.singleView) return;

    this.closeOpenDialogs();
    this.singleView.hidden = true;
    this.allView.hidden = false;
    this.setActive('all');
    document.body.classList.add('blog-view-all');

    if (this.headingEl) {
      this.headingEl.textContent = this.allLabel;
    }
    if (this.breadcrumbTitleEl) {
      this.breadcrumbTitleEl.textContent = this.allLabel;
    }

    const allTotalCount = parseInt(this.dataset.allTotalCount, 10) || 0;
    this.allItems = Array.from(this.allView.querySelectorAll('[data-blog-all-item]'));

    if (this.allPaginationRoot) {
      this.allPaginationRoot.style.display = (allTotalCount === 0 || this.allItems.length === 0) ? 'none' : '';
    }

    this.updateFilterBtnVisibility(allTotalCount === 0 || this.allItems.length === 0);

    if (allTotalCount > this.allItems.length && !this.isFetching) {
      this.fetchMissingArticles();
    } else {
      this.renderAllPage();
    }
  }

  async fetchMissingArticles() {
    if (this.isFetching) return;
    this.isFetching = true;
    const allTotalCount = parseInt(this.dataset.allTotalCount, 10) || 0;

    try {
      const targetGrid = this.allView.querySelector('[data-blog-all-grid]');
      if (!targetGrid) return;

      const filterVal = new URLSearchParams(window.location.search).get('filter');
      const filterQuery = filterVal ? `&filter=${encodeURIComponent(filterVal)}` : '';
      const currentUrl = `${window.location.pathname}?section_id=${this.targetId}&limit=250&view=all${filterQuery}`;
      const response = await fetch(currentUrl);
      if (response.ok) {
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const fetchedAllGrid = doc.querySelector(`[data-blog-view-root="${this.targetId}"][data-blog-view="all"] [data-blog-all-grid]`);
        if (fetchedAllGrid) {
          const fetchedItems = Array.from(fetchedAllGrid.querySelectorAll('[data-blog-all-item]'));
          if (fetchedItems.length > this.allItems.length) {
            targetGrid.innerHTML = fetchedAllGrid.innerHTML;
            this.allItems = Array.from(this.allView.querySelectorAll('[data-blog-all-item]'));
          }
        }
      }

      if (this.allItems.length < allTotalCount) {
        const parser = new DOMParser();
        const navTabs = Array.from(this.querySelectorAll('[data-blog-tab]'));
        for (const tab of navTabs) {
          const blogHandle = tab.dataset.blogTab;
          if (!blogHandle || blogHandle === 'all' || blogHandle === this.currentBlog) continue;
          if (this.allItems.length >= allTotalCount) break;

          const blogUrl = tab.getAttribute('href');
          if (!blogUrl) continue;

          const secUrl = `${blogUrl.split('?')[0]}?section_id=${this.targetId}&limit=250${filterQuery}`;
          const res = await fetch(secUrl);
          if (res.ok) {
            const secText = await res.text();
            const doc = parser.parseFromString(secText, 'text/html');
            const singleGrid = doc.querySelector(`[data-blog-view-root="${this.targetId}"][data-blog-view="single"] .blog-posts-container`);
            if (singleGrid) {
              const newItems = Array.from(singleGrid.querySelectorAll('.blog-post-item'));
              const existingUrls = new Set(this.allItems.map((el) => el.querySelector('a')?.href).filter(Boolean));

              for (const item of newItems) {
                const link = item.querySelector('a')?.href;
                if (link && !existingUrls.has(link)) {
                  existingUrls.add(link);
                  item.setAttribute('data-blog-all-item', '');
                  item.hidden = true;
                  targetGrid.appendChild(item);
                }
              }
              this.allItems = Array.from(this.allView.querySelectorAll('[data-blog-all-item]'));
            }
          }
        }
      }
    } catch (err) {
      console.error('Failed to load all articles:', err);
    } finally {
      this.isFetching = false;
      this.renderAllPage();
    }
  }

  showSingle() {
    if (!this.allView || !this.singleView) return;

    this.closeOpenDialogs();
    this.allView.hidden = true;
    this.singleView.hidden = false;
    this.setActive(this.currentBlog);
    document.body.classList.remove('blog-view-all');

    const activeTab = this.tabs.find((tab) => tab.dataset.blogTab === this.currentBlog);
    const activeTitle = activeTab ? activeTab.textContent.trim() : '';
    if (activeTitle) {
      if (this.headingEl) {
        this.headingEl.textContent = activeTitle;
      }
      if (this.breadcrumbTitleEl) {
        this.breadcrumbTitleEl.textContent = activeTitle;
      }
    }

    if (this.countEl) {
      this.countEl.textContent = this.originalCountText;
    }
    this.updateFilterBtnVisibility(this.originalCount === 0);
    this.renderSinglePage();
  }

  updateFilterBtnVisibility(isEmpty) {
    const hasActiveFilter = new URLSearchParams(window.location.search).has('filter') ||
      window.location.pathname.includes('/tagged/');
    if (isEmpty && !hasActiveFilter) {
      if (this.toolbar) this.toolbar.style.display = 'none';
    } else {
      if (this.toolbar) this.toolbar.style.display = '';
    }
  }

  setActive(key) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.blogTab === key;
      tab.classList.toggle('blog-posts__tab--active', isActive);
      if (isActive) {
        tab.setAttribute('aria-current', 'page');
      } else {
        tab.removeAttribute('aria-current');
      }
    });
    this.toggleVideoBodyClass(key);
  }

  toggleVideoBodyClass(activeKey) {
    const isVideoActive = activeKey === this.videoBlogHandle;
    document.body.classList.toggle('all_blog_video', isVideoActive);
    document.documentElement.classList.toggle('all_blog_video', isVideoActive);
  }

  setAllItemsPerPage(count) {
    this.allItemsPerPage = count;
    this.allCurrentPage = 1;
    this.renderAllPage();
  }

  goToAllPage(pageNumber) {
    const totalPages = Math.max(1, Math.ceil(this.allItems.length / this.allItemsPerPage));
    if (pageNumber < 1 || pageNumber > totalPages) return;
    this.allCurrentPage = pageNumber;
    this.renderAllPage();

    if (this.allView) {
      this.allView.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  renderAllPage() {
    const totalItems = this.allItems.length;
    const allTotalCount = parseInt(this.dataset.allTotalCount, 10) || 0;

    if (!totalItems || allTotalCount === 0) {
      if (this.allPaginationRoot) {
        this.allPaginationRoot.style.display = 'none';
      }
      return;
    }

    this.updateFilterBtnVisibility(false);

    if (this.toolbar) {
      this.toolbar.style.display = '';
    }

    const totalPages = Math.max(1, Math.ceil(totalItems / this.allItemsPerPage));
    if (this.allCurrentPage > totalPages) this.allCurrentPage = totalPages;

    if (totalPages <= 1) {
      if (this.allPaginationRoot) this.allPaginationRoot.style.display = 'none';
    } else {
      if (this.allPaginationRoot) this.allPaginationRoot.style.display = '';
    }

    const startIndex = (this.allCurrentPage - 1) * this.allItemsPerPage;
    const endIndex = startIndex + this.allItemsPerPage;

    this.allItems.forEach((item, index) => {
      item.hidden = index < startIndex || index >= endIndex;
    });

    // Update count text
    if (this.countEl) {
      const displayTotal = !isNaN(allTotalCount) && allTotalCount > 0 ? allTotalCount : totalItems;
      const label = displayTotal === 1 ? this.singularLabel : this.pluralLabel;
      this.countEl.textContent = `${displayTotal} ${label}`;
    }

    // Render page number buttons (max 4 visible at a time)
    if (this.allPageNumbersEl) {
      this.allPageNumbersEl.innerHTML = '';

      const maxVisible = 4;
      let startPage = 1;
      let endPage = totalPages;

      if (totalPages > maxVisible) {
        startPage = Math.max(1, this.allCurrentPage - 1);
        endPage = startPage + maxVisible - 1;

        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = Math.max(1, endPage - maxVisible + 1);
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'blog-posts__all-page-btn';
        if (i === this.allCurrentPage) btn.classList.add('blog-posts__all-page-btn--active');
        btn.textContent = i;
        btn.setAttribute('aria-label', `Page ${i}`);
        btn.addEventListener('click', () => this.goToAllPage(i));
        this.allPageNumbersEl.appendChild(btn);
      }
    }

    // Update per-page active state
    this.allPerPageButtons.forEach((btn) => {
      const isActive = parseInt(btn.dataset.blogAllPerPageBtn, 10) === this.allItemsPerPage;
      btn.classList.toggle('blog-posts__all-per-page-btn--active', isActive);
    });

    // Toggle prev/next disabled state
    if (this.allPrevBtn) this.allPrevBtn.disabled = this.allCurrentPage === 1;
    if (this.allNextBtn) this.allNextBtn.disabled = this.allCurrentPage === totalPages;
  }

  setSingleItemsPerPage(count) {
    this.singleItemsPerPage = count;
    this.singleCurrentPage = 1;
    this.renderSinglePage();
  }

  goToSinglePage(pageNumber) {
    const totalPages = Math.max(1, Math.ceil(this.singleItems.length / this.singleItemsPerPage));
    if (pageNumber < 1 || pageNumber > totalPages) return;
    this.singleCurrentPage = pageNumber;
    this.renderSinglePage();

    if (this.singleView) {
      this.singleView.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  renderSinglePage() {
    this.singleItems = this.singleView ? Array.from(this.singleView.querySelectorAll('[data-blog-single-item]')) : [];
    const totalItems = this.singleItems.length;

    if (!totalItems) {
      if (this.singlePaginationRoot) {
        this.singlePaginationRoot.style.display = 'none';
      }
      return;
    }

    const totalPages = Math.max(1, Math.ceil(totalItems / this.singleItemsPerPage));
    if (this.singleCurrentPage > totalPages) this.singleCurrentPage = totalPages;

    if (totalPages <= 1) {
      if (this.singlePaginationRoot) this.singlePaginationRoot.style.display = 'none';
    } else {
      if (this.singlePaginationRoot) this.singlePaginationRoot.style.display = '';
    }

    const startIndex = (this.singleCurrentPage - 1) * this.singleItemsPerPage;
    const endIndex = startIndex + this.singleItemsPerPage;

    this.singleItems.forEach((item, index) => {
      item.hidden = index < startIndex || index >= endIndex;
    });

    // Render page number buttons (max 4 visible at a time)
    if (this.singlePageNumbersEl) {
      this.singlePageNumbersEl.innerHTML = '';

      const maxVisible = 4;
      let startPage = 1;
      let endPage = totalPages;

      if (totalPages > maxVisible) {
        startPage = Math.max(1, this.singleCurrentPage - 1);
        endPage = startPage + maxVisible - 1;

        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = Math.max(1, endPage - maxVisible + 1);
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'blog-posts__all-page-btn';
        if (i === this.singleCurrentPage) btn.classList.add('blog-posts__all-page-btn--active');
        btn.textContent = i;
        btn.setAttribute('aria-label', `Page ${i}`);
        btn.addEventListener('click', () => this.goToSinglePage(i));
        this.singlePageNumbersEl.appendChild(btn);
      }
    }

    // Update per-page active state
    this.singlePerPageButtons.forEach((btn) => {
      const isActive = parseInt(btn.dataset.blogSinglePerPageBtn, 10) === this.singleItemsPerPage;
      btn.classList.toggle('blog-posts__all-per-page-btn--active', isActive);
    });

    // Toggle prev/next disabled state
    if (this.singlePrevBtn) this.singlePrevBtn.disabled = this.singleCurrentPage === 1;
    if (this.singleNextBtn) this.singleNextBtn.disabled = this.singleCurrentPage === totalPages;
  }
}

if (!customElements.get('blog-assignment-tabs')) {
  customElements.define('blog-assignment-tabs', BlogAssignmentTabs);
}